import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
import { IsSupportedText, IsTruthyWhen, SupportedLineMode } from '../../shared/validator';
/**
 * The notes that may be configured to appear on a receipt
 */
export class ReceiptNotes {
    /**
     * @param isVisible Whether the text should appear on receipts
     * @param text Notes to appear on receipts, if visible
     */
    constructor(isVisible, text) {
        this.isVisible = isVisible;
        this.text = text;
    }
}
ReceiptNotes.MAX_TEXT_LENGTH = 1000;
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReceiptNotes.prototype, "isVisible", void 0);
__decorate([
    IsSupportedText(SupportedLineMode.MULTI),
    Length(0, ReceiptNotes.MAX_TEXT_LENGTH),
    IsTruthyWhen('isVisible', true, {
        message: 'Text cannot be empty when notes are visible.',
    }),
    __metadata("design:type", String)
], ReceiptNotes.prototype, "text", void 0);
export const DEFAULT_RECEIPT_NOTES = new ReceiptNotes(false, '');
